import TableGeneric from '../../../compartidos/abms/TableGeneric'
import { Grid, Paper, Typography } from "@material-ui/core"
import { BuscadorMedicamentos } from './BuscadorMedicamentos'
import { useSelector } from 'react-redux'

import { useState } from 'react'

const formatter = new Intl.ListFormat("es-AR", { style: 'long', type: 'conjunction' })

export const RecetasDigitalesMedicamentosABM = () => {

  const { buscadorMedicamentos } = useSelector((state) => state.medicamentos);
  const [selectedVal, setSelection] = useState([])

  return (
    <Grid container spacing={4} style={{
      padding: "1rem"
    }}>
      <Grid item xs={12}>
        <Grid container justify="center">
          <Grid item xs={6} component={Paper} style={{
            padding: "1rem"
          }}>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="overline">Buscar Medicamentos</Typography>
              </Grid>
              <Grid item xs={12}>
                <BuscadorMedicamentos
                  label="Presentación | Laboratorio | Nombre | Drogas"
                  handleSelection={(value) => {
                    setSelection(value)
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} component={Paper}>
        <TableGeneric
          data={selectedVal.length ? selectedVal : buscadorMedicamentos}
          tituloSinResultado="Sin resultados, indique parametros de busqueda."
          columns={[
            {
              label: "Laboratorio",
              id: "laboratorio"
            },
            {
              label: "Nombre",
              id: "nombre"
            },
            {
              label: "Drogas",
              customBody: (x) => formatter.format(x.drogas.split(","))
            },
            {
              label: "Presentación",
              id: "presentacion"
            }
          ]}
        />
      </Grid>

    </Grid>
  )
}
